import { render, staticRenderFns } from "./500.vue?vue&type=template&id=6cefb384&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cefb384",
  null
  
)

export default component.exports